import { render } from "./tournament_leaderboard_section.vue?vue&type=template&id=476aabba"
import script from "./tournament_leaderboard_section.vue?vue&type=script&lang=js"
export * from "./tournament_leaderboard_section.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__